// removed by extract-text-webpack-plugin
module.exports = {"plist":"plist__21m3-","pname":"pname__1giUw","pval":"pval__1wEaO","error":"error__3E4VE","punit":"punit__3wJwF","cancelBtn":"cancelBtn__1JIZ4","submitBtn":"submitBtn__2NKrJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PropsPanel/styles.scss
// module id = 2142
// module chunks = 1